import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TaggingOptions, UiKitModule } from '@serviceplan/ui-kit';
import { AssetUIModel, ClientCoreModule, PROMPTS, ValueListsService } from '@thehubz/client/core';
import { UserInfo } from '@thehubz/client/data-access-api';
import { AnyType } from '@thehubz/shared/model';
import { CustomTitleCasePipe } from '../../../../../../../../pipes/custom-title-case.pipe';
import { AssetCommonService } from '../../../../../../../../services/asset-common.service';
import { AssetMetadata } from '../../../../../models/asset-info.interface';

@Component({
  selector: 'thehubz-arval-asset-metadata',
  templateUrl: './arval-asset-metadata.component.html',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, ClientCoreModule, UiKitModule, CustomTitleCasePipe],
})
export class ArvalAssetMetadataComponent implements OnChanges {
  @Input() assetInfoObject!: AssetMetadata;
  @Input() editFlag = false;
  @Input() asset!: AssetUIModel;

  @Output() taggedUser = new EventEmitter<UserInfo[]>();
  @Output() descriptionText = new EventEmitter<string>(); // emit editor text

  textIsRequired = PROMPTS.TEXT.IS_REQUIRED;

  arvalMetadataForm: UntypedFormGroup;
  taggingOptions: TaggingOptions = {
    roles: ['global.library', 'asset.update'],
  };

  constructor(
    private _formBuilder: UntypedFormBuilder,
    protected assetCommonService: AssetCommonService,
    protected valueListsService: ValueListsService,
  ) {
    this.arvalMetadataForm = this._formBuilder.group({
      name: ['', Validators.required],
      status: ['', Validators.required],
      description: '',
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['asset']?.currentValue) {
      this.asset = changes['asset'].currentValue;
    }
  }

  patchFormValues() {
    this.assetCommonService.patchFormValues(this.asset, this.arvalMetadataForm);
  }

  /**
   * store tagged user list when user tagged get at sp-editor
   * @param userList
   */
  taggedUserList(userList: UserInfo[]) {
    this.taggedUser.emit(userList);
  }

  editorDescriptionText(text: string) {
    this.descriptionText.emit(text);
  }

  onDateSelection(evt: MatDatepickerInputEvent<AnyType, AnyType>) {
    this.asset.assetExpiryDays = this.assetCommonService.getAssetExpireDays(evt.value);
  }
}
